module.exports = __webpack_public_path__ + "img/blues_logo.ffa62b08.png";